import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import pkg from 'root/package.json';

const config = payload.global.sentry;
const useSentry = config.enabled;

/**
 * Logging helper class, using Sentry on production.
 *
 * @see https://docs.sentry.io/platforms/javascript/vue/
 */
export default {
  init() {
    if (useSentry) {
      Sentry.init({
        dsn: config.dsn,
        release: `${pkg.name}@${pkg.version}`,
        environment: config.environment,
        integrations: [
          new Integrations.Vue({
            Vue,
            attachProps: true,
          }),
        ]
      });
    }
  },
  captureException(err) {
    if (useSentry) {
      Sentry.captureException(err);
    } else {
      console.log(err);
    }
  }
};
